import { Component, Inject, OnInit } from '@angular/core';
import { AuthService as Auth0AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.resource';
import { UserAccessHandler } from '../../features/users/services/user-access-handler.service';
import { UserInfoHandler } from '../../features/users/services/user-info-handler.service';
import { UtilsApiService } from '../../utils/shared-services/utils.resource';
import { UserSecurityApiService } from '../../features/users/services/user-security.resource';
import { StoreApiService } from '../../features/stores/services/store.resource';
import { ConceptApiService } from '../../features/concepts/services/concept.resource';
import { WebUserSecurityWithStoreList } from '../../features/users/models/user-security.model';
import { UserRole } from '../../features/users/enums/user-role.enum';
import { StoreGroupMembersApiService } from '../../features/store-groups/services/store-group-member.resource';
import { TagApiService } from '../../features/tags/services/tag.resource';

@Component({
    selector: 'sso-auth',
    template: `<p>Processing SSO login...</p>`,
    standalone: false
})

export class SSOAuthComponent implements OnInit {

    public user: any;
    public portalLogin: boolean = false;


    constructor(
        @Inject(Auth0AuthService) private auth: Auth0AuthService,
        @Inject(Router) private router: Router,
        @Inject(AuthService) private authService: AuthService,
        @Inject(UserAccessHandler) private userAccessHandler: UserAccessHandler,
        @Inject(UserInfoHandler) private userInfoHandler: UserInfoHandler,
        @Inject(UtilsApiService) private utilsApiService: UtilsApiService,
        @Inject(UserSecurityApiService) private userSecurityApiService: UserSecurityApiService,
        @Inject(StoreApiService) private storeApiService: StoreApiService,
        @Inject(ConceptApiService) private conceptApiService: ConceptApiService,
        @Inject(StoreGroupMembersApiService) private storeGroupMembersApiService: StoreGroupMembersApiService,
        @Inject(TagApiService) private tagApiService: TagApiService,
    ) { }

    ngOnInit() {
        this.auth.idTokenClaims$.subscribe((claims) => {
            this.authService.ssoLogin(claims).then((res: any) => {
                if (res.token) {
                    this.userInfoHandler.setToken(res.token);
                    this.utilsApiService.getUserInfo().then((userInfo: any) => {
                        let showDashboardByDefault = userInfo.showDashboardOnLogin === 1 ? true : false;
                        let userMustResetPassword = !!userInfo.resetPassOnLogin;
                        this.userInfoHandler.setFirstName(userInfo.firstName);
                        this.userInfoHandler.setLastName(userInfo.lastName);
                        this.userInfoHandler.setShowDashboardByDefault(showDashboardByDefault);
                        this.userInfoHandler.setEmail(userInfo.email);
                        this.userInfoHandler.setTheme(userInfo.theme);
                        this.userInfoHandler.setResetPassOnLogin(userMustResetPassword);
                        this.userAccessHandler.setUserPrivilege(userInfo.userPrivilege);
                        this.userAccessHandler.setUserManagement(userInfo.userManagement);

                        this.userInfoHandler.setSSOLogin(userInfo.ssologin);  
                        this.userInfoHandler.setLanguage(userInfo.language);
                        this.userInfoHandler.setFavouriteTabID(userInfo.favouriteTabID);

                        this.userSecurityApiService.getCurrentUserSecurity().then((currentUserSecurity: WebUserSecurityWithStoreList) => {
                            this.userAccessHandler.setUserID(currentUserSecurity.webUserID);
                            this.userAccessHandler.setConceptID(currentUserSecurity.conceptID);
                            this.userAccessHandler.setGroupItemID(currentUserSecurity.groupItemID);
                            this.userAccessHandler.setTagID(currentUserSecurity.tagID);
                            this.userAccessHandler.setStoreID(currentUserSecurity.storeID);
                            this.userAccessHandler.setRole(currentUserSecurity.role);
                            this.userAccessHandler.setLimitation(currentUserSecurity.limitation);
                            this.getAndSetRoleItem(currentUserSecurity);
                        });
                        let privileges = JSON.parse(userInfo.userPrivilege);
                        for (let privilege of privileges) {
                            if (privilege.name == "STORE_PORTAL_ADMIN_ONLY" || privilege.name == "STORE_PORTAL_USER_ONLY")
                                this.portalLogin = true
                        }

                        if (userMustResetPassword) {
                            this.router.navigate(['users/changePassword']);
                        } else if (showDashboardByDefault && !this.portalLogin) {
                            this.router.navigate(['/dashboard']);
                        } else if (this.portalLogin) {
                            this.router.navigate(['concepts/allConcepts']);
                        } else {
                            this.router.navigate(['home']);
                        }
                    });
                }

            });
        });

    }

    getAndSetRoleItem(userSecurity: WebUserSecurityWithStoreList) {
        if (userSecurity.role === UserRole.Concept) {
            this.conceptApiService.getConceptById(userSecurity.conceptID).then((concept) => {
                this.userAccessHandler.setRoleItem(concept);
            });
        } else if (userSecurity.role === UserRole.GroupItem) {
            this.storeGroupMembersApiService.getStoreGroupItemById(userSecurity.groupItemID).then((groupItem) => {
                this.userAccessHandler.setRoleItem(groupItem);
            });
        } else if (userSecurity.role === UserRole.Tag) {
            this.tagApiService.getTagById(userSecurity.tagID).then((tag) => {
                this.userAccessHandler.setRoleItem(tag);
            });
        } else if (userSecurity.role === UserRole.Store) {
            this.storeApiService.getStoreById(userSecurity.storeID).then((store) => {
                this.userAccessHandler.setRoleItem(store);
            });
        } else {
            this.userAccessHandler.setRoleItem(null);
        }
    }

}
